import { TrendingUp } from 'lucide-react';
import { StatusBadge } from './StatusBadge';
import { AdminFunnelsCard } from './AdminFunnelsCard';

export function AdminOverviewTab({ stats, bookings }) {
  return (
    <div className="space-y-6">
      <div className="grid md:grid-cols-2 gap-6">
      <div className="card-surface p-6">
        <h3 className="font-heading text-xl font-medium text-[#1A1A1A] mb-4 flex items-center gap-2">
          <TrendingUp className="h-5 w-5 text-[#D4AF37]" />
          Revenue (Last 14 Days)
        </h3>
        <div className="space-y-2">
          {stats?.daily_revenue?.map((day) => (
            <div key={day.date} className="flex items-center gap-3">
              <span className="text-xs text-stone-400 w-20 flex-shrink-0">{day.date.slice(5)}</span>
              <div className="flex-1 bg-stone-100 rounded-full h-4 overflow-hidden">
                <div
                  className="h-full bg-[#D4AF37] rounded-full transition-all"
                  style={{ width: `${Math.min(100, stats?.total_revenue > 0 ? (day.revenue / stats.total_revenue) * 100 * 5 : 0)}%` }}
                />
              </div>
              <span className="text-xs font-medium text-[#1A1A1A] w-16 text-right">£{day.revenue.toFixed(0)}</span>
              <span className="text-xs text-stone-400 w-8 text-right">{day.count}</span>
            </div>
          ))}
        </div>
      </div>
      <div className="card-surface p-6">
        <h3 className="font-heading text-xl font-medium text-[#1A1A1A] mb-4">Recent Bookings</h3>
        {bookings.length === 0 ? (
          <p className="text-stone-500 text-center py-8">No bookings yet</p>
        ) : (
          <div className="space-y-3">
            {bookings.slice(0, 8).map((b) => (
              <div key={b.booking_id} className="flex items-center justify-between p-3 bg-[#F9F6F0] rounded-lg">
                <div className="min-w-0 flex-1">
                  <p className="font-medium text-[#1A1A1A] text-sm truncate">{b.service_name}</p>
                  <p className="text-xs text-stone-500">{b.client_name}, {b.date}</p>
                </div>
                <StatusBadge status={b.status} />
              </div>
            ))}
          </div>
        )}
      </div>
      </div>
      <AdminFunnelsCard />
    </div>
  );
}
